"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var GridFilter_1 = require("../model/GridFilter");

var GridFilterConverter_1 = require("./GridFilterConverter");

var GridFilterConverterImpl =
/*#__PURE__*/
function (_GridFilterConverter_) {
  _inherits(GridFilterConverterImpl, _GridFilterConverter_);

  function GridFilterConverterImpl() {
    _classCallCheck(this, GridFilterConverterImpl);

    return _possibleConstructorReturn(this, _getPrototypeOf(GridFilterConverterImpl).apply(this, arguments));
  }

  _createClass(GridFilterConverterImpl, [{
    key: "toObject",

    /**
     * @inheritDoc
     */
    value: function toObject(source, conversions) {
      var _this = this;

      var convertedFilter = {};
      Object.keys(source.filter).forEach(function (colId) {
        var filter = source.filter[colId];

        switch (filter.filterType) {
          case 'text':
            convertedFilter[colId] = _this.gridSimpleFilterTextToObj(filter, conversions);
            break;

          case 'number':
            if (filter.type === 'inRange') {
              convertedFilter[colId] = _this.gridSimpleFilterNumberRangeToObj(filter, conversions);
            } else {
              convertedFilter[colId] = _this.gridSimpleFilterNumberToObj(filter, conversions);
            }

            break;

          case 'set':
            convertedFilter[colId] = _this.gridSimpleFilterSetToObj(filter, conversions);
            break;

          case 'date':
            convertedFilter[colId] = _this.gridSimpleFilterDateToObj(filter, conversions);
            break;

          case 'custom':
            if (filter.type === 'date') {
              convertedFilter[colId] = _this.gridCustomFilterDateToObj(filter, conversions);
            }

            break;
        }
      });
      var convertedSort = source.sorting.map(function (sort) {
        return _this.gridFilterSortToObj(sort, conversions);
      });
      return new GridFilter_1.GridFilter(convertedFilter, convertedSort);
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "toDocument",
    value: function toDocument(source, conversions) {
      var _this2 = this;

      if (typeof source !== 'object' || source === null) {
        return null;
      }

      var document = {
        filter: {},
        sorting: []
      };
      Object.keys(source.filter).forEach(function (colId) {
        var filter = source.filter[colId];
        var convertedFilter = {};

        switch (filter.filterType) {
          case 'text':
            convertedFilter[colId] = _this2.gridSimpleFilterTextToDoc(filter, conversions);
            break;

          case 'number':
            if (filter.type === 'inRange') {
              convertedFilter[colId] = _this2.gridSimpleFilterNumberRangeToDoc(filter, conversions);
            } else {
              convertedFilter[colId] = _this2.gridSimpleFilterNumberToDoc(filter, conversions);
            }

            break;

          case 'set':
            convertedFilter[colId] = _this2.gridSimpleFilterSetToDoc(filter, conversions);
            break;

          case 'date':
            convertedFilter[colId] = _this2.gridSimpleFilterDateToDoc(filter, conversions);
            break;

          case 'custom':
            if (filter.type === 'date') {
              convertedFilter[colId] = _this2.gridCustomFilterDateToDoc(filter, conversions);
            }

            break;
        }

        document.filter = Object.assign(document.filter, convertedFilter);
      });
      Object.assign(document, {
        sorting: source.sorting.map(function (sort) {
          return _this2.gridFilterSortToDoc(sort, conversions);
        })
      });
      return document;
    }
  }, {
    key: "gridSimpleFilterTextToObj",
    value: function gridSimpleFilterTextToObj(source, conversions) {
      return new GridFilter_1.GridSimpleFilterText(source.type, source.filter);
    }
  }, {
    key: "gridSimpleFilterTextToDoc",
    value: function gridSimpleFilterTextToDoc(source, conversions) {
      return {
        filterType: source.filterType,
        type: source.type,
        filter: source.filter
      };
    }
  }, {
    key: "gridSimpleFilterNumberToObj",
    value: function gridSimpleFilterNumberToObj(source, conversions) {
      return new GridFilter_1.GridSimpleFilterNumber(source.type, source.filter);
    }
  }, {
    key: "gridSimpleFilterNumberToDoc",
    value: function gridSimpleFilterNumberToDoc(source, conversions) {
      return {
        filterType: source.filterType,
        type: source.type,
        filter: source.filter
      };
    }
  }, {
    key: "gridSimpleFilterNumberRangeToObj",
    value: function gridSimpleFilterNumberRangeToObj(source, conversions) {
      return new GridFilter_1.GridSimpleFilterNumberRange(source.filter, source.filterTo);
    }
  }, {
    key: "gridSimpleFilterNumberRangeToDoc",
    value: function gridSimpleFilterNumberRangeToDoc(source, conversions) {
      return {
        filterType: source.filterType,
        type: source.type,
        filter: source.filter,
        filterTo: source.filterTo
      };
    }
  }, {
    key: "gridSimpleFilterSetToObj",
    value: function gridSimpleFilterSetToObj(source, conversions) {
      return new GridFilter_1.GridSimpleFilterSet(source.values);
    }
  }, {
    key: "gridSimpleFilterSetToDoc",
    value: function gridSimpleFilterSetToDoc(source, conversions) {
      return {
        filterType: source.filterType,
        values: source.values
      };
    }
  }, {
    key: "gridSimpleFilterDateToObj",
    value: function gridSimpleFilterDateToObj(source, conversions) {
      return new GridFilter_1.GridSimpleFilterDate(source.from ? conversions.toDate(source.from) : undefined, source.to ? conversions.toDate(source.to) : undefined);
    }
  }, {
    key: "gridSimpleFilterDateToDoc",
    value: function gridSimpleFilterDateToDoc(source, conversions) {
      return {
        filterType: source.filterType,
        from: source.from ? conversions.fromDate(source.from) : undefined,
        to: source.to ? conversions.fromDate(source.to) : undefined
      };
    }
  }, {
    key: "gridCustomFilterDateToObj",
    value: function gridCustomFilterDateToObj(source, conversions) {
      return new GridFilter_1.GridCustomFilterDate(source.from ? conversions.toDate(source.from) : undefined, source.to ? conversions.toDate(source.to) : undefined);
    }
  }, {
    key: "gridCustomFilterDateToDoc",
    value: function gridCustomFilterDateToDoc(source, conversions) {
      return {
        filterType: source.filterType,
        type: source.type,
        from: source.from ? conversions.fromDate(source.from) : undefined,
        to: source.to ? conversions.fromDate(source.to) : undefined
      };
    }
  }, {
    key: "gridFilterSortToObj",
    value: function gridFilterSortToObj(source, conversions) {
      return new GridFilter_1.GridFilterSort(source.colId, source.sort);
    }
  }, {
    key: "gridFilterSortToDoc",
    value: function gridFilterSortToDoc(source, conversions) {
      return {
        colId: source.colId,
        sort: source.sort
      };
    }
  }]);

  return GridFilterConverterImpl;
}(GridFilterConverter_1.GridFilterConverter);

exports.GridFilterConverterImpl = GridFilterConverterImpl;